/**
 * The three outcome colours (CR-33), shared by the segmented bars, the time chart and their legend
 * so the three cannot drift apart: completed in orchid, still open in the light orchid step, and
 * no-show or cancelled in apricot — the pair tokens.css validated for colour-vision deficiency,
 * plus a lightness step of the first.
 */
export const OUTCOME_COLOURS = {
  completed: 'var(--chart-1)',
  open: 'var(--chart-seq-3)',
  lost: 'var(--chart-2)',
} as const;
